import React from "react";
import { Box, Container, Typography, Link, Divider } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { ROUTES_PATH } from "../../../utils/Consts";

function HomeFooterUI() {
    return (
        <Box
            component="footer"
            sx={{
                backgroundColor: '#2c3e50',
                color: 'white',
                py: 4,
                mt: 8,
                width: '100%',
            }}
        >
            <Container maxWidth="lg">
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: { xs: 'column', md: 'row' },
                        justifyContent: 'space-between',
                        alignItems: { xs: 'center', md: 'flex-start' },
                        gap: 3,
                    }}
                >
                    {/* Información de la empresa */}
                    <Box sx={{ textAlign: { xs: 'center', md: 'left' } }}>
                        <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold' }}>
                            PANADERIA Y PASTELERIA EL ROSAL
                        </Typography>
                        <Typography variant="body2" sx={{ color: '#ecf0f1' }}>
                            Carrera 78 No. 8 A 25 Barrio Castilla
                        </Typography>
                        <Typography variant="body2" sx={{ color: '#ecf0f1' }}>
                            Bogotá D.C., Colombia
                        </Typography>
                        <Typography variant="body2" sx={{ color: '#ecf0f1', mt: 1 }}>
                            Email: elrosalpanaderia7@gmail.com
                        </Typography>
                    </Box>

                    {/* Enlaces legales */}
                    <Box sx={{ textAlign: { xs: 'center', md: 'left' } }}>
                        <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold' }}>
                            Información Legal
                        </Typography>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                            <Link
                                component={RouterLink}
                                to={ROUTES_PATH.PRIVACYPOLICY}
                                sx={{
                                    color: '#ecf0f1',
                                    textDecoration: 'none',
                                    '&:hover': {
                                        color: '#3498db',
                                        textDecoration: 'underline',
                                    },
                                }}
                            >
                                Política de Privacidad
                            </Link>
                            <Link
                                component={RouterLink}
                                to={ROUTES_PATH.TERMSANDCONDITIONS}
                                sx={{
                                    color: '#ecf0f1',
                                    textDecoration: 'none',
                                    '&:hover': {
                                        color: '#3498db',
                                        textDecoration: 'underline',
                                    },
                                }}
                            >
                                Términos y Condiciones
                            </Link>
                        </Box>
                    </Box>

                    {/* Redes sociales o información adicional */}
                    <Box sx={{ textAlign: { xs: 'center', md: 'left' } }}>
                        <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold' }}>
                            Horario de Atención
                        </Typography>
                        <Typography variant="body2" sx={{ color: '#ecf0f1' }}>
                            Lunes a Sábado
                        </Typography>
                        <Typography variant="body2" sx={{ color: '#ecf0f1' }}>
                            6:00 AM - 9:30 PM
                        </Typography>
                        <Typography variant="body2" sx={{ color: '#ecf0f1' }}>
                            Domingos: 6:30 AM - 9:00 PM
                        </Typography>
                    </Box>
                </Box>

                <Divider sx={{ my: 3, backgroundColor: '#7f8c8d' }} />

                <Box sx={{ textAlign: 'center' }}>
                    <Typography variant="body2" sx={{ color: '#bdc3c7' }}>
                        © {new Date().getFullYear()} Panadería y Pastelería El Rosal. Todos los derechos reservados.
                    </Typography>
                </Box>
            </Container>
        </Box>
    );
}

export { HomeFooterUI };
